//Library
import React, { Component } from 'react';
import ReactHighcharts from 'react-highcharts';
import Swal from 'sweetalert2';
import { withRouter } from 'react-router';
import { renderToStaticMarkup } from 'react-dom/server';
import { pushBNDataLayer } from '../../utils/analytics.js';
//redux
import { connect } from 'react-redux';
import { saveCombinItem } from '../../action/anueInfoAction';

class InvestGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            colorByMktName: {},
            trialGid: "",
        }
    }

    getHighchart = (data, context, gdName, prompt, gid) => {
        let convertData = [];
        for (let i = 0; i <= data.length - 1; i++) {
            let item = { name: data[i].mktName, y: data[i].ratio, funds: data[i].funds, context: context, gdName: gdName, color: this.getColorByData(data[i].mktName, gid), prompt: prompt };
            convertData.push(item);
        }
        let trialCalculationConfig = {
            chart: { plotBackgroundColor: null, plotBorderWidth: null, plotShadow: false, type: 'pie', height: 330 },
            title: { text: "" },
            legend: { align: 'left', labelFormatter: function () { return this.name + this.percentage + '%'; } },
            plotOptions: {
                column: { stacking: 'percent' },
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: { enabled: false },
                    showInLegend: true,
                    colors: ["rgb(238,202,75)", "rgb(57,158,218)", "rgb(147,199,82)", "rgb(138,151,161)"],
                    point: {
                        events: {
                            legendItemClick: function () {
                                return false;
                            }
                        }
                    }

                },
                series: {
                    point: {
                        events: {
                            click: function () {
                                Swal.fire({
                                    html: renderToStaticMarkup(<div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title titleFont" id="featureModalLabel">{this.gdName}
                                            </h5>
                                        </div>
                                        <div className="modal-body">
                                            <div className="combination">
                                                <div>
                                                    <div className="combinationName">
                                                        <h5>{this.name}</h5>
                                                        <div className="tag">{this.percentage}%</div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <ul className="fundList" style={{ textAlign: "left" }}>
                                                        {
                                                            this.options.funds.map(({ shortName, ratingOverall, rtn1Year, rtn2Year, rtn3Month, rtn3Year, rtn6Month, rtnYTD }, index) => {
                                                                let starRating = "";
                                                                for (let i = 0; i <= Number(ratingOverall) - 1; i++) {
                                                                    starRating += "★";
                                                                }
                                                                return <li className={"clickLi LiIndex_" + index} data-index={index} key={Math.round(Math.random() * 1000000)}>
                                                                    <span style={{ width: "85%", display: "inline-block" }}>{shortName}</span>
                                                                    <i className="fas fa-chevron-circle-down" style={{ color: "#008cd6", fontSize: "20px", display: "inline-block", marginLeft: "5px", verticalAlign: "super" }} onClick={(evt) => { }}></i>
                                                                    <table style={{ display: "none" }} className={"rtnTable table_" + index}>
                                                                        <thead>
                                                                            <tr><th style={{ backgroundColor: "#73cfff", height: "22px", borderRadius: "8px 8px 0 0" }} colSpan="6">報酬率(%)</th></tr>
                                                                            <tr>
                                                                                <th style={{ fontSize: "12px", padding: "0", fontWeight: "100", borderRadius: 0, height: "22px", width: "16%" }}>3個月</th>
                                                                                <th style={{ fontSize: "12px", padding: "0", fontWeight: "100", height: "22px", width: "16%" }}>6個月</th>
                                                                                <th style={{ fontSize: "12px", padding: "0", fontWeight: "100", height: "22px", width: "16%" }}>1年</th>
                                                                                <th style={{ fontSize: "12px", padding: "0", fontWeight: "100", height: "22px", width: "16%" }}>2年</th>
                                                                                <th style={{ fontSize: "12px", padding: "0", fontWeight: "100", height: "22px", width: "16%" }}>3年</th>
                                                                                <th style={{ fontSize: "12px", padding: "0", fontWeight: "100", borderRadius: 0, height: "22px", width: "25%" }}>成立以來</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td style={{ color: (Number(rtn3Month) > 0 ? "red" : "green"), fontSize: "12px", height: "33px" }}>{(Number(rtn3Month)).toFixed(1)}</td>
                                                                                <td style={{ color: (Number(rtn6Month) > 0 ? "red" : "green"), fontSize: "12px", height: "33px" }}>{(Number(rtn6Month)).toFixed(1)}</td>
                                                                                <td style={{ color: (Number(rtn1Year) > 0 ? "red" : "green"), fontSize: "12px", height: "33px" }}>{(Number(rtn1Year)).toFixed(1)}</td>
                                                                                <td style={{ color: (Number(rtn2Year) > 0 ? "red" : "green"), fontSize: "12px", height: "33px" }}>{(Number(rtn2Year)).toFixed(1)}</td>
                                                                                <td style={{ color: (Number(rtn3Year) > 0 ? "red" : "green"), fontSize: "12px", height: "33px" }}>{(Number(rtn3Year)).toFixed(1)}</td>
                                                                                <td style={{ color: (Number(rtnYTD) > 0 ? "red" : "green"), fontSize: "12px", height: "33px" }}>{(Number(rtnYTD)).toFixed(1)}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                        <tfoot>
                                                                            <tr>
                                                                                <td colSpan="5" style={{ height: "auto", fontSize: "12px", textAlign: "left" }}>Lipper評等：{starRating}</td>
                                                                            </tr>
                                                                        </tfoot>
                                                                    </table>
                                                                </li>
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                            <span style={{ fontSize: "12px", lineHeight: "13px", textAlign: "left", display: "block", marginTop: "10px" }}>
                                                <span>資料來源：Lipper & 投信投顧公會 & 台灣集中保管結算所。績效為累積報酬，截至</span>
                                                {this.prompt}。
                                                <span style={{ color: "#008cd6" }}>過去績效不代表未來績效之保證，歷史資料僅供參考。</span>
                                            </span>
                                        </div>
                                    </div>),
                                    showCloseButton: true,
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    onClose: (toast) => { toast.removeEventListener("click", this.toggerLi, toast.getElementsByClassName("clickLi")) },
                                    onOpen: (toast) => {
                                        toast.getElementsByClassName("table_0")[0].style.display = "";
                                        toast.getElementsByClassName("LiIndex_0")[0].getElementsByTagName("i")[0].className = "fas fa-chevron-circle-up";
                                        toast.addEventListener("click", (evt) => {
                                            let getParentLi = (elm) => {
                                                try {
                                                    let flag = true;
                                                    let rtnElm = elm;
                                                    while (flag) {
                                                        if (rtnElm.tagName === "LI") {
                                                            return rtnElm;
                                                        } else {
                                                            rtnElm = rtnElm.parentElement;
                                                        }
                                                    }
                                                } catch (evt) { return undefined }

                                            }
                                            let parentElm = getParentLi(evt.target);
                                            if (parentElm === undefined)
                                                return;
                                            if (parentElm.getElementsByTagName("table")[0].style.display === "") {
                                                parentElm.getElementsByTagName("i")[0].className = "fas fa-chevron-circle-down";
                                                parentElm.getElementsByTagName("table")[0].style.display = "none";
                                                return;
                                            }
                                            let allLi = document.getElementsByClassName("clickLi");
                                            for (let i = 0; i <= allLi.length - 1; i++) {
                                                allLi[i].getElementsByTagName("i")[0].className = "fas fa-chevron-circle-down";
                                                allLi[i].getElementsByTagName("table")[0].style.display = "none";
                                            }
                                            document.getElementsByClassName("table_" + parentElm.dataset.index)[0].style.display = "";
                                            parentElm.getElementsByTagName("i")[0].className = "fas fa-chevron-circle-up";
                                        }, toast.getElementsByClassName("clickLi"));
                                    }
                                })
                            }
                        }
                    }
                }
            },
            series: [{ name: 'Brands', colorByPoint: true, data: convertData }],
            tooltip: {
                useHTML: true,
                formatter: function () {
                    let tooltips = '<div>' + this.series.data[this.colorIndex].name + this.series.data[this.colorIndex].percentage + '%<ul>';
                    for (let i = 0; i <= this.series.data[this.colorIndex].funds.length - 1; i++) {
                        tooltips += '<li>' + this.series.data[this.colorIndex].funds[i].shortName + '</li>';
                    }
                    tooltips += '</ul></div>'
                    return tooltips
                }
            }
        }
        return <ReactHighcharts config={trialCalculationConfig}></ReactHighcharts>
    }

    toggerLi = (evt) => {
        ;
        let getParentLi = (elm) => {
            try {
                let flag = true;
                let rtnElm = elm;
                while (flag) {
                    if (rtnElm.tagName === "LI") {
                        return rtnElm;
                    } else {
                        rtnElm = rtnElm.parentElement;
                    }
                }
            } catch (evt) { return undefined }

        }
        let parentElm = getParentLi(evt.target);
        if (parentElm === undefined)
            return;
        if (parentElm.getElementsByTagName("table")[0].style.display === "") {
            parentElm.getElementsByTagName("i")[0].className = "fas fa-chevron-circle-down";
            parentElm.getElementsByTagName("table")[0].style.display = "none";
            return;
        }
        let allLi = document.getElementsByClassName("clickLi");
        for (let i = 0; i <= allLi.length - 1; i++) {
            allLi[i].getElementsByTagName("i")[0].className = "fas fa-chevron-circle-down";
            allLi[i].getElementsByTagName("table")[0].style.display = "none";
        }
        document.getElementsByClassName("table_" + parentElm.dataset.index)[0].style.display = "";
        parentElm.getElementsByTagName("i")[0].className = "fas fa-chevron-circle-up";
    }

    getColorByData = (mktName, gid) => {
        let color;
        if (this.props.trialGid === "" || (this.props.trialGid === gid)) {
            color = ["#558bc9", "#67c3c6", "#c4c84b", "#56aadd", "#65be91", "#f5e941", "#8ebfe1", "#8fc41e", "#f5ca1d", "#aed048"];
        } else {
            return "#A2A2A2"
        }
        if (Object.keys(this.state.colorByMktName).length === 0) {
            let colorByMktName = this.state.colorByMktName;
            colorByMktName[mktName] = color[Object.keys(this.state.colorByMktName).length];
            this.setState({ colorByMktName: colorByMktName })
            return color[0];
        } else {
            if (this.state.colorByMktName[mktName] !== undefined) {
                return this.state.colorByMktName[mktName];
            } else {
                let colorByMktName = this.state.colorByMktName;
                colorByMktName[mktName] = color[Object.keys(this.state.colorByMktName).length];
                this.setState({ colorByMktName: colorByMktName })
                return color[Object.keys(this.state.colorByMktName).length];
            }
        }
    }

    //投組點擊 立即申購 直接進入選擇基金 不需再選投組
    goStep1(item) {
        pushBNDataLayer(item.gid,item.gdName);
        this.props.saveCombinItem(item);
        this.props.history.push("/Purchase");
    }

    getGroupText() {
        if (this.props.trialAnswer <= 0.2 && this.props.isOverRange === false) {
            return [
                <div className="secText center" data-aos="fade-up">試算後，您的預期年化報酬率為<span>{(this.props.trialAnswer * 100).toFixed(1)}%</span></div>,
                <div className="secText center" style={{ border: "none" }} data-aos="fade-up">適合您的投資組合為：{this.props.CombinList.filter(value => { return (value.gid === this.props.trialGid) })[0]?.gdName}</div>
            ]
        } else if (this.props.trialAnswer <= 0.2 && this.props.isOverRange === true) {
            return <div className="secText center" style={{ border: "none" }} data-aos="fade-up">試算後，您的預期年化報酬率為<span>{(this.props.trialAnswer * 100).toFixed(1)}%</span>，目前投組無法滿足您的親子理財試算需求，請重新計算。</div>
            
        } else if(this.props.trialAnswer > 0.2){
            return <div className="secText center" data-aos="fade-up">試算後，您的預期年化報酬率為已經超過20%，目前投組無法滿足您的親子理財試算需求，請重新計算。</div>
        }
    }

    render() {
        return <div>
            <span className="investArrow">▲</span>
            <div className="investHr"></div>
            <section id="invest">
                <div className="anueContainer">
                    <div className="titleBlock">
                        <h2 data-aos="flip-up"><i className="fas fa-chart-pie" style={{ marginRight: "5px" }}></i>投資組合輕鬆選</h2>
                    </div>
                    {
                            this.getGroupText()
                    }
                </div>
            </section>
            <div className="secContent bg_tri">
                <div className="anueContainer">
                    <div className="featureBlock chartBlock">
                        {
                            this.props.CombinList !== undefined ?
                                this.props.CombinList.map(({ gdName, context, median, marketingList, prompt, gid, allowAcc }, index) => {
                                    return <div className="divisionBlock" data-aos="fade-right" key={index}>
                                        <div className="gaps">
                                            <div className={"featureBox" + (this.props.trialGid === gid ? " featureBoxActive" : "")}>
                                                <div className="tag" style={{ backgroundColor: (this.props.trialGid !== "" && this.props.trialGid !== gid ? "#A2A2A2" : "") }}>{gdName}</div>
                                                <div className="chartBox">
                                                    <div className="ring_chart" id="ringChartWrap1">
                                                        {this.getHighchart(marketingList, context, gdName, prompt, gid)}
                                                    </div>
                                                </div>
                                                <div className="numBoxContainer">
                                                    <div className="numBox">
                                                        <div>
                                                            <h5>預期報酬率範圍</h5>
                                                        </div>
                                                        <div>
                                                            <p style={{ color: (this.props.trialGid !== "" && this.props.trialGid !== gid ? "#A2A2A2" : "") }}>{median}</p>
                                                        </div>
                                                        <div>
                                                            <button onClick={() => { this.goStep1({ gid, gdName, context, marketingList, allowAcc }) }} style={{ backgroundColor: (this.props.trialGid !== "" && this.props.trialGid !== gid ? "#A2A2A2" : "") }}>立即申購</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }) : ""
                        }
                    </div>
                </div>
            </div>
        </div >
    }
}

export default connect(() => { return {} }, { saveCombinItem })(withRouter(InvestGroup));